/**
 * Tools that open a configuration step before confirming.
 * Single source for handleSelect + initial view when editing (initialToolId).
 */
export const TOOL_DETAIL_SELECT_CONFIG = {
  assignment: { view: 'assign_to_team' },
  create_negotiation: { view: 'create_negotiation_details' },
  move_negotiation: { view: 'move_negotiation_details' },
  send_file: { view: 'send_file' },
  trigger_whatsapp_flow: { view: 'trigger_whatsapp_flow' },
  purchase_intention: { view: 'purchase_intention_details' },
  create_order: { view: 'create_order_details' },
  get_payment_link: { view: 'get_payment_link_details' },
  retrieve_products: { view: 'retrieve_products_details' },
  retailer_api_request: { view: 'retailer_api_request', resetRetailerDraft: true },
  get_customer_crm_data: { view: 'get_customer_crm_data' }
};

export const getDetailViewForToolId = (toolId) => (
  TOOL_DETAIL_SELECT_CONFIG[toolId]?.view ?? 'list'
);
